<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 17 16">
    <path
      fill="#006252"
      d="M14.55 7.12a.48.48 0 0 0-.48-.4H8.72a.5.5 0 0 0-.5.5v1.71c0 .28.22.5.5.5h3.1c-.34 1.72-1.74 2.7-3.6 2.7A4.05 4.05 0 0 1 4.25 8c0-2.3 1.77-4.14 3.97-4.14.77 0 1.49.24 2.1.64.21.15.51.14.7-.05l1.27-1.33c.19-.2.18-.53-.04-.7A6.48 6.48 0 0 0 8.22 1 6.84 6.84 0 0 0 1.5 8c0 3.88 3 7 6.72 7 3.35 0 6.4-2.55 6.4-7 0-.28-.02-.58-.07-.88Z"
    />
  </svg>
</template>
